import { useState, useEffect } from "react";
import _ from "lodash";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";

import { getLabel } from "../../tools/Dictionary";

const ProcessDesignerCopy = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const Data = props.Data;
  const Step = props.Step;
  const OnCloseModal = props.OnCloseModal;
  const OnConfirm = props.OnConfirm;

  //Init
  const initData = () => {

    return Data.map(d => {

      return {
        ...d,
        prevTitle: d.title
      }
    });

  };


  //State
  const [form, setForm] = useState(initData());
  const [error, setError] = useState({
  });
  const [valid, setValid] = useState(true);
  
  const [loading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  const onChangeTitle = (e, _index) => {

    let currentForm = _.cloneDeep(form);

    let title = e.target.value;

    if (title && title.length > 60) return;

    currentForm[_index].title = title;

    setForm(currentForm);

  };

  //Validate field
  useEffect(() => {

    let currentError = {};
    let isValid = true;

    //f.title == f.prevTitle || 

    form.forEach((f, index) => {

      if (!f.title){
        currentError[index] = getLabel("Validation", "This field can't be empty.");
      }else if (f.title.length > 60){
        currentError[index] = getLabel("Validation", "This field has exceeded the character limit.") + `[60]`;
      }else if (Step.findIndex(s => s.title == f.title) > -1 || form.findIndex(fr => fr.title == f.title && fr.prevTitle != f.prevTitle) > -1){
        currentError[index] = getLabel("Validation", "Value already exists.");//"The selected title already exists. Please select another one."
      }else
        currentError[index] = undefined;

      if (currentError[index]) isValid = false;

    });
    
    setValid(isValid);

    setError(currentError);

  }, [form, Step]);

  const onClickConfirm = () => {

    try
    {

      if (!valid) throw new Error(getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."));


      OnConfirm(form);


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };



  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ProcessDesigner", "Confirm selected steps")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row" style={{}}>
            <div className="processdesigner_copy_subtitle">
              {getLabel("ProcessDesigner", "Please confirm the new names of the duplicated steps")}
            </div>
          </div>
          {form.map((d, index) => (
            <div className="page_modal_body_row" key={index}>
              <div className="processdesigner_copy_item_title">
                {d.prevTitle}
              </div>
              <div className="processdesigner_copy_item_input">
                <input
                  className={"page_text_input " + (error[index] ? "page_modal_body_col_input_error" : "")}
                  value={d.title || ""}
                  onChange={(e) => onChangeTitle(e, index)}
                  type="text"
                  style={{ width: "50%", textAlign: "center" }}
                  disabled={!Access.canWrite || loading}
                />
              </div>
              {error[index] &&
                <div className="processdesigner_copy_item_title page_modal_body_col_error" style={{marginTop: "5px"}}>
                  {error[index]}
                </div>
              }
            </div>
          ))}
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {(Access.canWrite && !ReadOnly) &&
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Confirm")}
              style={{ maxWidth: "200px" }}
              onClick={(loading) ? undefined : onClickConfirm}
              disabled={loading}
            />
          }
        </div>
      </div>
    </div>
  );

};

export default ProcessDesignerCopy